import { render } from "./UserColumnsPage.vue?vue&type=template&id=a5ded780&scoped=true&ts=true&lang=pug"
import script from "./UserColumnsPage.vue?vue&type=script&lang=ts"
export * from "./UserColumnsPage.vue?vue&type=script&lang=ts"

import "./UserColumnsPage.vue?vue&type=style&index=0&id=a5ded780&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5ded780"]])

export default __exports__